export interface IConfigYmaps {
  apiKey: string;
  suggestApiKey: string;
}

export const YMAPS_MODULES: string[] = ['Map', 'Placemark', 'control.ZoomControl'];

export function loadYmapsApi({ apiKey, suggestApiKey }: IConfigYmaps): Promise<YMaps.IYMaps> {
  return new Promise((resolve, reject) => {
    if (window.ymaps) {
      resolve(window.ymaps);

      return;
    }

    const element = document.createElement('script');
    element.src = `https://enterprise.api-maps.yandex.ru/2.1/?apikey=${apiKey}&suggest_apikey=${suggestApiKey}&lang=ru-RU&load=${YMAPS_MODULES.join(
      ',',
    )}`;
    element.async = true;
    element.defer = true;
    element.onload = () => {
      window.ymaps.ready({
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-expect-error
        successCallback(ymaps: YMaps.IYMaps) {
          resolve(ymaps);
        },
        errorCallback(error: Error) {
          reject(error);
        },
        require: [],
      });
    };
    element.onerror = () => {
      document.body.removeChild(element);
      reject(new Error('Unable to load Yandex Maps API'));
    };
    document.body.appendChild(element);
  });
}
